import React from 'react';

import { InjectSagaArgs } from '../utils/injectSaga';
import getInjectors from '../utils/sagaInjectors';
import StoreInstance from '../utils/StoreInstance';

const useInjectSaga = ({ key, saga, mode }: InjectSagaArgs): void => {
  React.useEffect(() => {
    const injectors = getInjectors(StoreInstance.store);
    injectors.injectSaga(key, { saga, mode });

    return () => {
      injectors.ejectSaga(key);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useInjectSaga;
